import axios from 'axios';
import { API } from '@/config/api';

const state = {
    users: [],
}

const getters = {
    getUsers: (state) => state.users,
}

const mutations = {
    setUsers: (state, users) => {
        state.users = users;
    },
}

const actions = {
    async fetchUsers({ commit }) {
        try {
            const response = await axios.post(
                API.GET_USERS,
                {
                    "token": "test",
                    "companyId": 1,
                    "page": 0,
                    "limit": 50
                }
            );

            if (response.status === 200) {
                commit('setUsers', response.data.response.users);
                
            } else {
                
            }
        } catch (error) {
            console.error('Error fetching users:', error);
        }
    },
}

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions,
}
